import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faStickyNote, 
  faCalculator, 
  faLock, 
  faCheck, 
  faExclamationTriangle, 
  faSpinner 
} from '@fortawesome/free-solid-svg-icons';
import useNotes from '../hooks/useNotes';

const Notes = ({ locataireId, notes: initialNotes }) => {
  // Use our custom hook to manage notes
  const { notes, saveStatus, handleNoteChange } = useNotes(locataireId, initialNotes);
  
  // Render save indicator with Font Awesome icons
  const renderSaveIndicator = (noteType) => {
    const status = saveStatus[noteType];
    if (!status) return null;
    
    return (
      <span className={`save-indicator ${status}`} aria-live="polite">
        {status === 'saving' && (
          <>
            <FontAwesomeIcon icon={faSpinner} spin /> Sauvegarde...
          </>
        )}
        {status === 'saved' && (
          <>
            <FontAwesomeIcon icon={faCheck} /> Sauvegardé
          </>
        )}
        {status === 'error' && (
          <>
            <FontAwesomeIcon icon={faExclamationTriangle} /> Erreur
          </>
        )}
      </span>
    );
  };
  
  return (
    <article className="bloc notes-container">
      <div className="notes-grid">
        <div className="note-box">
          <fieldset className="note-fieldset">
            <legend className="note-legend">
              <FontAwesomeIcon icon={faStickyNote} /> 
              <span className="note-title">Note gestion paiement</span>
              {renderSaveIndicator('gestionPaiement')}
            </legend>
            <textarea 
              id="noteGestionPaiement" 
              name="noteGestionPaiement"
              className="note-textarea"
              placeholder="Saisir une note concernant la gestion des paiements..."
              value={notes.gestionPaiement}
              onChange={(e) => handleNoteChange('gestionPaiement', e.target.value)}
            />
          </fieldset>
        </div>
        
        <div className="note-box">
          <fieldset className="note-fieldset">
            <legend className="note-legend">
              <FontAwesomeIcon icon={faCalculator} /> 
              <span className="note-title">Note compta 2023</span>
              {renderSaveIndicator('compta2023')}
            </legend>
            <textarea 
              id="noteCompta2023" 
              name="noteCompta2023"
              className="note-textarea"
              placeholder="Saisir une note concernant la comptabilité 2023..."
              value={notes.compta2023}
              onChange={(e) => handleNoteChange('compta2023', e.target.value)}
            />
          </fieldset>
        </div>
        
        <div className="note-box">
          <fieldset className="note-fieldset">
            <legend className="note-legend">
              <FontAwesomeIcon icon={faLock} /> 
              <span className="note-title">Note privée</span>
              {renderSaveIndicator('privee')}
            </legend>
            <textarea 
              id="notePrivee" 
              name="notePrivee"
              className="note-textarea"
              placeholder="Saisir une note privée concernant ce bail..."
              value={notes.privee}
              onChange={(e) => handleNoteChange('privee', e.target.value)}
            />
          </fieldset>
        </div>
      </div>
    </article>
  );
};

export default Notes;
